var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"padding-top":"1rem","width":"2.5rem","height":"2.5rem"},attrs:{"id":"Spinner"}})}
var staticRenderFns = []

export { render, staticRenderFns }